import { render } from "./EventDetail.vue?vue&type=template&id=5c6392ca&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=5c6392ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c6392ca"

export default script